import React from 'react';
import FeatureHighlight from '@boschebike/ebds-react/dist-esm/components/FeatureHighlight.js';

/**
 * @typedef {import('../../App.d.ts').ComponentFeatureHighlight} ComponentFeatureHighlight
 */
/**
 * @param {ComponentFeatureHighlight} props
 * @returns {React.js.Element}
 * @constructor
 */
export default ({
  headline,
  elements,
  imgPosition = 'left',
  imgUrl,
  imgAlt,
  portraitImgUrl = null,
  autoWidth = true,
}) => (
  <FeatureHighlight
    headline={headline}
    elements={elements}
    imgPosition={imgPosition}
    imgUrl={imgUrl}
    imgAlt={imgAlt}
    portraitImgUrl={portraitImgUrl}
    autoWidth={autoWidth}
  />
);
